import { connect } from "react-redux";
import { createSelector } from "reselect";
import { Drawer as Component } from "./Drawer";
import { NOTEBOOK as PROTOCOL_NOTEBOOK } from "@learningblocks/protocol-constants/lib/Utilities";
import { NOTEBOOK as EXP_NOTEBOOK } from "@learningblocks/exp-constants/lib/Utilities";

function mapStateToProps(state) {
  return {
    visible: !state.notebook.notebookCollapsed,
    showOverlay: getShowOverlay(state),
    collapsed: state.notebook.notebookCollapsed,
  };
}

function mapDispatchToProps() {
  return {};
}

export const Drawer = connect(mapStateToProps, mapDispatchToProps)(Component);

const getCurrentSection = ({ notebook }) => notebook.currentSection;

const getShowOverlay = createSelector([getCurrentSection], (currentSection) =>
  currentSection &&
  (currentSection.title === EXP_NOTEBOOK.SECTION.DESIGN ||
    currentSection.title === PROTOCOL_NOTEBOOK.SECTION.PROTOCOL)
    ? false
    : true
);
